var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox',_vm._b({on:{"change":function($event){return _vm.$emit('input', $event)}}},'el-checkbox',_vm.$props,false),[_vm._t("label")],2),_vm._t("info"),(_vm.error)?_vm._t("custom-error"):_vm._e(),(!_vm.showError)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }